var map = {
	"./arrow_down.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/arrow_down.svg",
	"./edit.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/edit.svg",
	"./github.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/github.svg",
	"./heart.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/heart.svg",
	"./heart_on.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/heart_on.svg",
	"./reply.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/reply.svg",
	"./tip.svg": "./node_modules/raw-loader/dist/cjs.js!./src/assets/icon/tip.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icon sync recursive !!./node_modules/raw-loader/dist/cjs.js! ^\\.\\/.*\\.svg$";